import { openSecurityInfoCreatePopup } from 'data/securityInfo/securityInfo.actions';
import { getSecurityInfoCreatedId } from 'data/securityInfo/securityInfo.selectors';
import { SecurityInfo } from 'data/securityInfo/securityInfo.types';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldUpdateHandlerParam } from 'shared/form';
import { CollectionFunctionFormFieldHandler } from '../components/CollectionFunctionForm';

// eslint-disable-next-line import/prefer-default-export
export function useFieldCreateNewSecurityInfo(
  handleFieldUpdate: CollectionFunctionFormFieldHandler,
): [CollectionFunctionFormFieldHandler] {
  const idCreated = useSelector(getSecurityInfoCreatedId);
  const dispatch = useDispatch();
  const paramRef = useRef<FieldUpdateHandlerParam>();
  const formSectionRef = useRef<'hi2Interfaces' | 'hi3Interfaces'>();
  const tabIdRef = useRef<string>();

  useEffect(() => {
    if (idCreated == null || paramRef.current == null) {
      return;
    }

    const param = paramRef.current;
    if (param == null) {
      return;
    }

    paramRef.current = undefined;

    param.value = idCreated;
    // The value label may have been changed in the create dialog, so removing it to avoid confusion
    param.valueLabel = null;

    handleFieldUpdate(param, formSectionRef.current, tabIdRef.current);

  }, [idCreated]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFieldCreateNew: CollectionFunctionFormFieldHandler = (param, formSection, tabId) => {
    if (formSection !== 'hi2Interfaces' && formSection !== 'hi3Interfaces') {
      return;
    }

    const securityInfo: SecurityInfo = {
      id: '',
      name: param.valueLabel,
      intfType: 'HTTPS',
      tlsVersion: 'TLSv1.2',
      tlsType: 'Server',
      authenType: 'SIMPLE',
      privateKeyFile: 'server.key',
      passphrase: '',
      certificateFile: 'server.crt',
      certificateAuthority: 'root_cacert.perm.cert',
      certificateDirectory: '/usr/share/ssl/certs',
      description: '',
      depth: '',
      hostname: '',
      cipherFile: '',
      catype: 'SELFSIGNED'
    };

    dispatch(openSecurityInfoCreatePopup(securityInfo));

    paramRef.current = param;
    formSectionRef.current = formSection;
    tabIdRef.current = tabId;
  };

  return [handleFieldCreateNew];
}
